import { render, staticRenderFns } from "./Scam.vue?vue&type=template&id=0ef20edf&scoped=true&"
var script = {}
import style0 from "./Scam.vue?vue&type=style&index=0&id=0ef20edf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef20edf",
  null
  
)

export default component.exports